export default __webpack_public_path__ + "new-staff-yellow-icon.svg";